<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="5" :sm="24">
              <a-form-item :label="$t('cancel.userNickname')" prop="mobile">
                <a-input v-model="queryParam.nickname" :placeholder="$t('cancel.inputNickname')" allow-clear />
              </a-form-item>
            </a-col>
<!--            <a-col :md="5" :sm="24">-->
<!--              <a-form-item label="审核�?status">-->
<!--                <a-select placeholder="审核状�? v-model="queryParam.status" style="width: 100%" allow-clear>-->
<!--                  <a-select-option v-for="(d, index) in dict.type.user_cancel_status" :key="index" :value="d.value">{{ d.label }}</a-select-option>-->
<!--                </a-select>-->
<!--              </a-form-item>-->
<!--            </a-col>-->
            <template v-if="advanced">
              <a-col :md="5" :sm="24">
                <a-form-item :label="$t('cancel.cancelReason')" prop="reason">
                  <a-input v-model="queryParam.reason" :placeholder="$t('cancel.inputCancelReason')" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="5" :sm="24">
                <a-form-item :label="$t('cancel.auditFailReason')" prop="failReason">
                  <a-input v-model="queryParam.failReason" :placeholder="$t('cancel.inputAuditFailReason')" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="5" :sm="24">
                <a-form-item :label="$t('cancel.auditor')" prop="examineName">
                  <a-input v-model="queryParam.examineName" :placeholder="$t('cancel.inputAuditor')" allow-clear/>
                </a-form-item>
              </a-col>

            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('common.query') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('common.reset') }}</a-button>
<!--                <a @click="toggleAdvanced" style="margin-left: 8px">-->
<!--                  {{ advanced ? '收起' : '展开' }}-->
<!--                  <a-icon :type="advanced ? 'up' : 'down'"/>-->
<!--                </a>-->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
<!--        <a-button type="primary" @click="handleExport" v-hasPermi="['biz:cancel:export']">-->
<!--          <a-icon type="download" />导出-->
<!--        </a-button>-->
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        :statusOptions="dict.type.user_cancel_status"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: 'max-content' }"
      >
        <span slot="status" slot-scope="text, record">
          <a-badge 
            :status="record.status == 1 ? 'processing' : record.status == 2 ? 'success' : 'error'" 
            :text="record.status == 1 ? $t('cancel.pendingAudit') : record.status == 2 ? $t('cancel.auditSuccess') : $t('cancel.auditFailed')" 
          />
        </span>
        <span slot="examineTime" slot-scope="text, record">
          {{ parseTime(record.examineTime) }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="reason" slot-scope="text, record">
          <a-tooltip :title="record.reason" placement="topLeft">
            <div class="text-ellipsis-cell">
              {{ record.reason || '-' }}
            </div>
          </a-tooltip>
        </span>
        <span slot="failReason" slot-scope="text, record">
          <a-tooltip :title="record.failReason" placement="topLeft">
            <div class="text-ellipsis-cell">
              {{ record.failReason || '-' }}
            </div>
          </a-tooltip>
        </span>
        <span slot="operation" slot-scope="text, record">
<!--          <a-divider type="vertical" v-hasPermi="['biz:cancel:edit']" />-->
          <!-- v-hasPermi="['biz:cancel:edit']" -->
          <a v-if="record.status==1" @click="$refs.createForm.handleUpdate(record, undefined)">
            <a-icon type="edit" />{{ $t('cancel.audit') }}
          </a>
<!--          <a-divider type="vertical" v-hasPermi="['biz:cancel:remove']" />-->
<!--          <a @click="handleDelete(record)" v-hasPermi="['biz:cancel:remove']">-->
<!--            <a-icon type="delete" />删除-->
<!--          </a>-->
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => $t('table.total', { total })"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageCancel,listCancel, delCancel } from '@/api/biz/cancel'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Cancel',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  dicts: ['user_cancel_status'],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁�?
      // 非多个禁�?
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        mobile: null,
        reason: null,
        failReason: null,
        nickname: null,
        examineName: null,
        examineTime: null,
        pageNum: 1,
        pageSize: 10
      }
    }
  },
  filters: {
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t('cancel.userId'),
          dataIndex: 'userId',
          width: 100,
          align: 'center'
        },
        {
          title: this.$t('cancel.showId'),
          dataIndex: 'showId',
          width: 100,
          align: 'center'
        },
        {
          title: this.$t('cancel.userNickname'),
          dataIndex: 'nickname',
          width: 150,
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('cancel.cancelReason'),
          dataIndex: 'reason',
          width: 200,
          scopedSlots: { customRender: 'reason' },
          align: 'center'
        },
        {
          title: this.$t('cancel.auditStatus'),
          dataIndex: 'status',
          width: 120,
          align: 'center',
          customRender: (t) => {
            if(t == 1) {
              return this.$t('cancel.pendingAudit');
            }else if(t == 2) {
              return this.$t('cancel.auditSuccess')
            }else if(t == 3) {
              return this.$t('cancel.auditFailed')
            }
          }
        },
        {
          title: this.$t('cancel.auditFailReason'),
          dataIndex: 'failReason',
          width: 200,
          scopedSlots: { customRender: 'failReason' },
          align: 'center'
        },
        {
          title: this.$t('common.operation'),
          dataIndex: 'operation',
          width: 150,
          fixed: 'right',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  created () {
    this.getList()
  },
  watch: {
  },
  methods: {
    /** 查询用户注销列表 */
    getList () {
      this.loading = true
     pageCancel(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        userId: undefined,
        mobile: undefined,
        reason: undefined,
        status: undefined,
        failReason: undefined,
        examineName: undefined,
        examineTime: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('system.confirmDelete'),
        content: this.$t('system.confirmDeleteContent') + ids,
        onOk() {
          return delCancel(ids)
            .then(() => {
              that.getList()
              that.$message.success(
                that.$t('system.deleteSuccess'),
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          // that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('system.confirmExport'),
        content: this.$t('system.confirmExportContent'),
        onOk () {
          that.download('biz/user-cancel/export', {
            ...that.queryParam
          }, `${that.$t('cancel.exportFileName')}_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>

<style scoped lang="less">
@import '~@/styles/table-responsive.less';

.table-operations {
  display: block;
}

.text-ellipsis-cell {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 200px;
  width: 100%;
  display: block;
  margin: 0;
  padding: 0;
}
</style>
